import { returnBySessionStorage } from "../utils/storage";

export default {
	inserted: function (el, binding) {
		var permissionsString=returnBySessionStorage("USER_INFO");
		console.log(permissionsString);
	
		if(!permissionsString){
			el.remove();
		}else{
			try {
				var permissions=permissionsString.split(",");
				if (!permissions.includes(binding.value)) {
					el.remove();
				}
			} catch (error) {
				el.remove();
			}
		}
	},
	update: function (el, binding) {
		var permissionsString=returnBySessionStorage("USER_INFO");
		if(!permissionsString){
			el.remove();
		}else{
			try {
				var permissions=permissionsString.split(",");
				if (!permissions.includes(binding.value)) {
					el.remove();
				}
			} catch (error) {
				el.remove();
			}
		}
	}
}
